import { Extent } from 'ol/extent';

export const isExtent = (
  extent: Extent,
): extent is [number, number, number, number] => {
  const [x1, y1, x2, y2] = extent;

  return !(
    x1 === undefined ||
    y1 === undefined ||
    x2 === undefined ||
    y2 === undefined
  );
};
